<template lang='pug'>
  v-container.px-3.inventory-container(fluid)
    //- Detail dialog
    v-dialog( :fullscreen="isMobile" width="500" persistent :value='detailsDialog' transition="dialog-bottom-transition")
      Details(v-if='detailsDialog' @showProduct='productDialog = true' :request='currentRequest' @close="detailsDialog=false;" admin="change_inventory")
    //- Form inventory
    v-dialog(persistent :value='purchaseDialog'  max-width='800px' :fullscreen="isMobile" transition="dialog-bottom-transition" )
      ChangeInventoryForm(v-if='purchaseDialog' @close="purchaseDialog = false; fetch()")
    //- Content
    v-row.px-3.justify-space-between.align-center.my-0
      v-col.d-flex.justify-end(cols="12")
        //- Update btn
        v-btn.main-btn-gradient(small style="height: 48px;" @click="fetch()")
          v-icon mdi-refresh
        //- Date filter
        v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
          template(v-slot:activator='{ on }')
            v-btn.main-btn-gradient(small color='#3cbbc2', dark='', v-on='on' style="height: 48px;").mt-0
              v-icon mdi-calendar
              | {{$t('purchases.dates')}}
          v-card(style="border:3px solid #3cbbc2;").pa-2
            date-filter(@closeMenu="fetch('change_inventory', false, $event)" :currentType= 'currentType',)
    v-row.px-5.my-0
      MovementTransactions(
        title="Movimientos devoluciones"
        :movements="transactions.length.toString() || '0'"
        total=""
        utility=""
      )
    v-row.px-5.my-0 width="100%")
        v-row
          v-col.pb-0(cols="12" xs="6" sm="6" md="4")
            v-select.rounded-xl(
              :label="$t('purchases.filter_by_store')",
              elevation=0
              outlined
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row.my-
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
          v-col.pb-0.d-flex.create-btn(cols="12" xs="6" sm="6" md="8")
            v-btn.main-btn-gradient(small @click="purchaseDialog=true" style="height: 48px;").mt-0
              v-icon mdi-plus
              | Agregar cambio de inventario
        v-row
          v-col(cols='12' md='12')
            .card-transactions
              v-progress-linear(v-if="loading" indeterminate color="#008e95")
              .show-table-desktop
                v-data-table.elevation-0(:headers="headers" :items="transactions || []" :expanded.sync="expanded" item-key="name"  show-expand :search="search" hide-default-header)
                  //- Headers
                  template(v-slot:header="{ props }")
                    th(v-for="head in props.headers" stylw="height: 30px;")
                      | {{ head.text }}
                      v-tooltip(v-if="head.value== 'items'" bottom='')
                        template(v-slot:activator='{ attrs, on }')
                          v-icon(v-on='on') mdi-help-circle-outline
                        span
                          p Aquí se muestra las cantidades de cada producto
                          p y el movimiento en inventario que genera cada factura (Vienen →  Quedan)
                  //- Content
                  template( v-slot:item="props" )
                    tr(@click="props.item.items ? openDetail(props.item) : '' " :style="props.item.items ? 'cursor: pointer;' : ''")
                      td.text-xs-left
                        .datatable-cell-wrapper {{ props.item.reference_number }}
                      td.text-xs-left(hidden)
                        | {{props.item.items}}
                      td
                        span(v-html="productsInOrder(props.item.items)")
                      td.text-xs-left()
                        .datatable-cell-wrapper {{ props.item.total | numberFormat}}
                      td.text-xs-left
                        .datatable-cell-wrapper  {{ props.item.time | moment }}
                      td.text-xs-left.red--text(v-if="props.item.isCanceled || !props.item.items") Anulada
                      td.text-xs-left(v-else :style='props.item.status === "completed" ? "color: green":"color: #fb8c00"')
                        .datatable-cell-wrapper  {{props.item.status | translateStatus}}
                      td.text-xs-left()
                        .datatable-cell-wrapper {{ props.item.location_to ? props.item.location_to.name : ''}}
              v-list.show-table-mobile(two-line="" v-if="filteredTransactions.length > 0")
                v-list-item-group
                  template(v-for="(item, index) in filteredTransactions.slice(10*(page-1), 10*(page))")
                    v-list-item(:key="item.reference_number").notification
                        template(v-slot:default="{ active, toggle }")
                            v-list-item-content(@click="item.items ? openDetail(item) : '' ")
                                p.font-weight-bold # {{item.reference_number}}
                                p.mt-2 {{ item.location_to ? item.location_to.name : ''}}
                                p.mt-2.notification__date {{item.time | moment}} {{item.time | momentHours}}
                                p(v-if="item.isCanceled || !item.items").red--text.text-caption Anulada
                                p.mt-2(v-else) {{getstatus(item.items) | translateStatus}}
                                p.mt-2.font-weight-bold.notification__price {{ item.total | numberFormat}}
                        v-divider(v-if="index + 1 < filteredTransactions.length" :key="index")
                  v-pagination.my-4(v-model="page" :length="pageNumber")
              .show-table-mobile(v-else)
                NoResults(title="No tienes cambios de inventario", description="Puedes ver tus cambios de inventario en otro rango de fechas")
    //- old Content
    //- v-layout(wrap='')
      //- Title Mobile
      v-flex(md12='', v-show="getCurrentType !== null || field!==null || sold!==null"  :style="isMobile ? 'padding-left: 20px !important; padding-right: 20px !important;': ''")
        //- v-col(v-if="isMobile" cols="12" style="position: relative;")
          v-icon(style="z-index: 10; position: absolute; left: 0; top: 0;" size="65" color="#30b5bb" @click="$router.go(-1)") mdi-chevron-left
          h2.purchases__title.purchases__underline Cambio de inventario
        //- Desktop
        v-card(v-if="!isMobile")
          //- v-card-title.mb-4 Cambio de inventario
          //- Filter Date
          .text-center(style="display:flex; align-items:flex-start;margin-left: 25px !important").mt-2
            //- v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
              template(v-slot:activator='{ on }')
                v-btn(color='#3cbbc2', dark='', v-on='on' style="height: 48px;").mt-0
                  v-icon mdi-calendar
                  | {{$t('purchases.dates')}}
              v-card(style="border:3px solid #3cbbc2;").pa-2
                date-filter(@closeMenu="fetch('change_inventory', false, $event)" :currentType= 'currentType',)
            //- Select date filter
            //- .text-center(style="display:flex; align-items:center;")
              v-select.elevation-0(
              :label="$t('purchases.filter_by_store')",
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
            v-card(style='margin: 2px;' flat link @click="purchaseDialog=true" outlined).category-card.py-6.mx-4
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Agregar cambio de inventario
                    img.mr-4.ml-2(style='height:36px' :src="addPurchaseIcon")
          //- Cards Statics
          v-flex(style='display:flex; flex-direction: row; flex-wrap: wrap; justify-content:flex-start; align-items:center;')
            v-flex(sm6='', xs12='', md6='', lg4='')
              base-material-stats-card( v-if ='!!transactions'  color='warning', icon='mdi-swap-vertical', small-value='#' :title="$t('purchases.movements')", :value='transactions.length.toString()')
          //- Table
          v-card
            v-progress-linear(v-if="loading" indeterminate color="cyan")
            v-data-table.elevation-0(:headers="headers" :items="transactions || []" :expanded.sync="expanded" item-key="name"  show-expand :search="search" hide-default-header)
              //- Headers
              template(v-slot:header="{ props }")
                th(v-for="head in props.headers" stylw="height: 30px;")
                  | {{ head.text }}
                  v-tooltip(v-if="head.value== 'items'" bottom='')
                    template(v-slot:activator='{ attrs, on }')
                      v-icon(v-on='on') mdi-help-circle-outline
                    span
                      p Aquí se muestra las cantidades de cada producto
                      p y el movimiento en inventario que genera cada factura (Vienen →  Quedan)
              //- Content
              template( v-slot:item="props" )
                tr(@click="props.item.items ? openDetail(props.item) : '' " :style="props.item.items ? 'cursor: pointer;' : ''")
                  td.text-xs-left
                    .datatable-cell-wrapper {{ props.item.reference_number }}
                  td.text-xs-left(hidden)
                    | {{props.item.items}}
                  td
                    span(v-html="productsInOrder(props.item.items)")
                  td.text-xs-left()
                    .datatable-cell-wrapper {{ props.item.total | numberFormat}}
                  td.text-xs-left
                    .datatable-cell-wrapper  {{ props.item.time | moment }}
                  td.text-xs-left.red--text(v-if="props.item.isCanceled || !props.item.items") Anulada
                  td.text-xs-left(v-else :style='props.item.status === "completed" ? "color: green":"color: #fb8c00"')
                    .datatable-cell-wrapper  {{props.item.status | translateStatus}}
                  td.text-xs-left()
                    .datatable-cell-wrapper {{ props.item.location_to ? props.item.location_to.name : ''}}
        //- Mobile
        v-container(v-else)
          .text-center(style="display:flex; align-items:flex-start;margin-left: 15px !important").mt-2
            .text-center(style="display:flex; align-items:center;")
              v-select.elevation-0.mr-4(
              :label="$t('purchases.filter_by_store')",
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
            v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
              template(v-slot:activator='{ on }')
                v-btn(color='#3cbbc2' small dark='', v-on='on' style="height: 38px;").mt-0
                  v-icon mdi-calendar
              v-card(style="border:3px solid #3cbbc2;").pa-2
                date-filter(@closeMenu="fetch('change_inventory', false, $event)" :currentType= 'currentType',)
          v-row.mt-2.mb-8.px-4.text-center
            v-col(cols="12" @click="purchaseDialog=true").pr-6
              v-btn.ma-2.white--text.btn-transaction(block)
                | {{$t('purchases.purchases_bill')}}
                v-icon(right="" dark="")
                  | mdi-plus
          //- Cards
          v-row.px-2
            v-col(cols="12")
              mobileCard(v-if ='!!transactions'  color='warning', icon='mdi-swap-vertical', valueIcon='#' :title="$t('purchases.movements')", :value='transactions.length.toString()')
          v-card
            v-progress-linear(v-if="loading" indeterminate color="cyan")
            //- Mobile
            v-flex(md12='' style="max-width: 700px").mx-auto.mt-3
              v-list(two-line="" v-if="filteredTransactions.length > 0")
                v-list-item-group
                  template(v-for="(item, index) in filteredTransactions.slice(10*(page-1), 10*(page))")
                    v-list-item(:key="item.reference_number").notification
                        template(v-slot:default="{ active, toggle }")
                            v-list-item-content(@click="item.items ? openDetail(item) : '' ")
                                p.font-weight-bold # {{item.reference_number}}
                                p.mt-2 {{ item.location_to ? item.location_to.name : ''}}
                                p.mt-2.notification__date {{item.time | moment}} {{item.time | momentHours}}
                                p(v-if="item.isCanceled || !item.items").red--text.text-caption Anulada
                                p.mt-2(v-else) {{getstatus(item.items) | translateStatus}}
                                p.mt-2.font-weight-bold.notification__price {{ item.total | numberFormat}}
                        v-divider(v-if="index + 1 < filteredTransactions.length" :key="index")
                  v-pagination.my-4(v-model="page" :length="pageNumber")
              template(v-else)
                NoResults(title="No tienes compras", description="Puedes ver tus compras en otro rango de fechas")
</template>

<script>
  import moment from 'moment'
  import DateFilter from '@/components/custom/filters/DateFilter'
  import loaders from '@/plugins/mixins/loaders'
  import addPurchaseIcon from '@/assets/icons/home/compra.png'
  export default {
    components: {
      DateFilter: DateFilter,
      ChangeInventoryForm: () => import('@/components/custom/forms/ChangeInventory'),
      NoResults: () => import('@/components/custom/NoResults'),
      Details: () => import('@/views/marketplace/component/profile/RequestDetails'),
      mobileCard: () => import('@/views/custom/transactions/MobileCard.vue'),
      MovementTransactions: () => import('@/components/custom/transactions/movement_transactions'),
    },
    filters: {
      moment: function (date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a')
      },
      momentHours: function (date) {
        return moment(date).format('hh:mm a')
      },
      translateStatus (value) {
        if (value) {
          switch (value) {
            case 'pending':
              return 'Pendiente'
            case 'completed':
              return 'Completo'
          }
        } else {
          return 'N/A'
        }
      },
      numberFormat (val) {
        if (val) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
    },
    mixins: [loaders],
    data () {
      return {
        loading: false,
        addPurchaseIcon,
        dateFrom: '',
        dateTo: '',
        page: 1,
        menu: false,
        currentLocation: null,
        select: {},
        confirmationDialog: false,
        currentItemId: null,
        selectedItem: {},
        purchaseDialog: false,
        transferDialog: false,
        expensesDialog: false,
        expanded: [],
        singleExpand: false,
        expensesExpanded: [],
        search: '',
        currentType: '',
        expenses: 0,
        // EXPENSES VARIABLES
        updateItemDialog: false,
        createItemDialog: false,
        // --FINISH EXPENSES VARIABLES
        dialog: false,
        headers: [
          {
            sortable: false,
            text: '# de referencia',
            value: 'type',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('purchases.table_headers.products'),
            value: 'items',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Total',
            value: 'total',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('purchases.table_headers.time'),
            value: 'time',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('purchases.table_headers.status'),
            value: 'status',
            align: 'left',
          },
          {
            sortable: false,
            text: this.$t('purchases.table_headers.destination'),
            value: 'location_to.name',
            align: 'left',
          },
          {
            text: '',
            value: 'data-table-expand',
          },
        ],
        tabs: 0,
        list: {
          0: false,
          1: false,
          2: false,
        },
        provider: null,
        selectedDate: null,
        transactionTotals: {
          qty: 0,
          revenue: 0,
          total: 0,
        },
        currentRequest: '',
        detailsDialog: false,
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      getCurrentType () {
        return this.$store.getters['transactions/getCurrentType']
      },
      field () {
        return {
          locations: this.$store.getters['shops/getItems'],
          categories: this.$store.getters['categories/getItems'],
        }
      },
      sold () {
        return this.$store.getters['transactions/getTransactionsTotal']
      },
      revenue () {
        return this.$store.getters['transactions/getRevenueTotal']
      },
      currentItem () {
        return this.$store.getters['products/getCurrentItem']
      },
      currentShop () {
        return this.$store.getters['shops/getCurrentItem']
      },
      products () {
        return [
          {
            name: 'Todos',
            value: '',
          },
          // ...this.$store.getters.getInventory,
        ]
      },
      changeInventory () {
        const vm = this
        return vm.$store.getters['transactions/getChangeInventory']
      },
      transactions () {
        const vm = this
        if (!!vm.currentLocation && !!vm.changeInventory) {
          return vm.changeInventory.filter((el) => {
            if (el.location_to.id === vm.currentLocation.id) {
              // console.log(el.location_to.id, vm.currentLocation.id)
              return true
            }
          })
        } else if (vm.changeInventory) {
          return vm.changeInventory
        } else {
          return vm.changeInventory
        }
      },
      pageNumber () {
        if (!this.transactions || this.transactions.length === 0) return 0
        if (this.isMobile) {
          return Math.ceil(this.filteredTransactions.length / 10)
        } else {
          return Math.ceil(this.transactions.length / 10)
        }
      },
      filteredTransactions () {
        if (!this.transactions || this.transactions.length === 0) return []
        return this.transactions.filter((transaction) => {
          return (transaction.location_to.name.toLowerCase().match(this.search.toLowerCase()) || transaction.reference_number.toString().includes(this.search))
        })
      },
    },
    watch: {
      $route (to, from) {
        // react to route changes...
        if (this.$route.params.type) {
          this.currentType = this.$route.params.type
          // console.log(this.$route.params.type)
        } else this.currentType = 'sales'
      },
      /* page (val, oldVal) {
        const vm = this
        if (val >= vm.pageNumber - 1) {
          vm.getNextPages()
        }
      }, */
    },
    created () {
      this.currentType = this.$route.params.type
      this.fetch()
    },
    beforeDestroy () {
      this.$store.dispatch('transactions/clearTransactions').then(function (res) {
      })
      this.clearShopSelection()
    },
    mounted () {},
    methods: {
      productsInOrder (products) {
        const vm = this
        let productsString = ''
        const style = 'display: flex; flex-direction: row; justify-content: space-between; width: 300px;'
        if (products) {
          products.forEach((product, index) => {
            const qty = product.qty || product.qty === 0 ? product.qty : null
            if (index !== products.length - 1) {
              productsString += `<div style="${style}"><p>${vm.overflowName(product.name)}</p><p>( ${qty} &#8594 ${+product.amount} )</p></div>`
            } else {
              productsString += `<div style="${style}"><p>${vm.overflowName(product.name)}</p><p>( ${qty} &#8594 ${+product.amount} )</p></div>`
            }
          })
        } else {
          return 'Esta compra no tiene productos'
        }
        if (productsString.length > 500) {
          return productsString.substring(0, 500) + '...'
        } else {
          return productsString
        }
      },
      overflowName (value) {
        if (value.length > 40) return value.substring(0, 40) + '...'
        return value
      },
      productsInOrderExcel (products) {
        let productsString = ''
        if (products) {
          products.forEach((product, index) => {
            if (index !== products.length - 1) {
              productsString += '(' + product.amount + ') ' + product.name + ', '
            } else {
              productsString += '(' + product.amount + ') ' + product.name
            }
          })
          return productsString
        } else {
          return 'Esta compra no tiene productos'
        }
      },
      openDeleteDialog (id) {
        const vm = this
        vm.currentItemId = id
        vm.confirmationDialog = true
        vm.localLoad = true
      },
      deleteExpensesItem (id) {
        const vm = this
        this.$store.dispatch('expenses/deleteItem', id).then(function () {
          vm.confirmationDialog = false
          vm.dialog = false
          vm.fetch()
        },
        ).catch(function (err) {
          console.log(err)
          vm.confirmationDialog = false
          vm.dialog = false
        })
      },
      loadLog (type, dateFrom, dateTo) {
        const vm = this
        vm.page = 1
        vm.$store.dispatch('transactions/loadLog', [type, dateFrom, dateTo, false, vm.provider]).then(function () {
          vm.loading = false
        })
      },
      fetch (type = 'change_inventory', initial = true, dates = null) {
        const vm = this
        vm.menu = false
        vm.loading = true
        vm.selectedDate = dates
        if (initial) {
          vm.dateFrom = vm.$moment().format('YYYY-MM-DD')
          vm.dateTo = vm.$moment(vm.dateFrom).add(1, 'days').format('YYYY-MM-DD')
          vm.loadLog(type, vm.dateFrom, vm.dateTo)
        } else {
          vm.dateFrom = moment(dates.from).format('YYYY-MM-DD')
          vm.dateTo = moment(dates.to).subtract(1, 'days').format('YYYY-MM-DD')
          vm.loadLog(type, vm.dateFrom, vm.dateTo)
        }
      },

      clearShopSelection () {
        const vm = this
        vm.$store.dispatch('shops/setCurrentItem', null).then(function () {
        })
      },
      selectShop (item) {
        const vm = this
        // console.log(item)
        vm.$store.dispatch('shops/setCurrentItem', item).then(function () {
          // console.log(vm.$store.getters['shops/getCurrentItem'])
        })
      },

      setSearchCriteria (val) {
        const vm = this

        vm.$store.dispatch('transactions/setFilterCriteria', val).then(function () {
          //
        })
      },
      setFilterCriteria () {
        const vm = this

        this.$store.dispatch('transactions/setFilterCriteria', vm.select).then(function () {
          //
        })
      },
      clearFilter () {
        const vm = this

        vm.$store.dispatch('clearFilter').then(function () {
          //
        })
      },

      getstatus (items) {
        // console.log(items)
        const found = items.find(element => element.status === 'pending')
        // console.log(found)
        if (found) {
          return 'pending'
        } else {
          return 'completed'
        }
      },
      openDetail (item) {
        const vm = this
        vm.currentRequest = item
        vm.detailsDialog = true
      },
    },
  }
</script>

<style lang='scss' scoped>
.inventory-container{
  .create-btn{
    justify-content: center;
  }
  @media(min-width: 600px) {
    .create-btn{
      justify-content: end !important;
    }
  }
  .card-transactions{

    overflow-y: scroll !important;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .show-table-mobile{
    padding-bottom: 50px;
  }
  @media(min-width: 760px) {
    .show-table-mobile{
      display: none !important;
    }
    .show-table-desktop{
      display: block !important;
    }
  }
  @media(max-width: 1100px) {
    .show-table-mobile{
      display: flex !important;
    }
    .show-table-desktop{
      display: none !important;
    }
  }
  .select {
    width: 60px;
    max-height: 60px;
    font-size: 11px;
  }
  .notification{
    display: flex;
    width: 95%;
    margin: 0 auto;
    // border-radius: 10px !important;
    box-shadow: -7px 4px 38px rgba(0, 0, 0, 0.16);
    &__container{
      @media (max-width: 1024px){
        background: transparent;
      }
    }
    &__date{
      font-size: 13px;
      color: #808184;
    }
    &__price{
      color: #35a3a9 !important;
    }
    &__description{
      color: #808184;
      font-size: 18px;
      font-weight: 300;
      line-height: 1.2;
    }
  }
  .purchases {
    &__title {
      text-align: center;
      color:#a3a4a5;
    }

    &__underline {
      position: relative;

      &:after {
        content:' ';
        position: absolute;
        top:120%;
        left:50%;
        width: 8rem;
        border:2px solid #30b5bb;
        border-radius:4px;
        transform:translateX(-50%);
      }
    }
  }
}
</style>
